import { reduce } from 'lodash';
import { State, CalculatorAnswers } from '../types';

export const serializeCalculatorAnswersToState = (calculatorAnswers: CalculatorAnswers) => {
  const update: State = {
    user_footprint: calculatorAnswers.user_footprint,
    average_footprint: calculatorAnswers.average_footprint,
    pledges: reduce((calculatorAnswers.pledges || {}), (previous, value, key) => ({
      ...previous,
      [key]: value.status
    }), {}),
    ui: {
      ...calculatorAnswers.ui,
      loadingCalculatorAnswers: false
    }
  };
  if (calculatorAnswers.ui.selectedLocation) {
    update.locationAutocomplete = {
      get_started__input_location: {
        inputDisplay: calculatorAnswers.ui.selectedLocation.formatted_address
      }
    };
  }
  return update;
};
